import { StocksApiRemoteService } from '../../Services/api/stocks/stocks-service'
import { IGetStockPayload, IStocksListResponse } from '../../Services/api/stocks/stocks.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ListStocksUseCase
implements IFormUsecase<IGetStockPayload, IStocksListResponse> {
  constructor (private readonly StocksApi: StocksApiRemoteService) {}
    

  public async handle (
    data: IGetStockPayload
  ): Promise<Result<IStocksListResponse>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.StocksApi.list(data)

      if (response.isFailure) {
        return response
      }

      const list = response.getValue()

      if(!list) return response

    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
